module.exports = __webpack_public_path__ + "img/M0031.2d4c3ae7.png";